import React from "react";
import { TextEditor } from "./TextEditor";

interface TextEditorWithJSONViewerProps {
  content: string;
  handleWikiChange: Function;
  disabled: boolean;
  isMaxSD: boolean;
  customStyle?: object;
  showToolbar?: boolean;
  enableMarkdown?: boolean;
}

export const TextEditorWithJSONViewer: React.FC<
  TextEditorWithJSONViewerProps
> = (props) => {
  // Since we're now using hover buttons for data examples instead of appending JSON to descriptions,
  // we can simply use the regular TextEditor
  return <TextEditor {...props} />;
};

export default TextEditorWithJSONViewer;
